module.exports = __webpack_public_path__ + "static/media/g2_traveler.f2f0d631.png";